import { useEffect } from 'react';

interface Props {
  onEscape: () => void;
  enabled?: boolean;
}

export default function useEscapeKey({ enabled = true, onEscape }: Props) {
  useEffect(() => {
    if (!enabled) return;

    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        event.preventDefault();
        event.stopPropagation();
        onEscape();
      }
    };

    const timeoutId = setTimeout(() => {
      document.addEventListener('keydown', handleKeyDown, true);
    }, 0);

    return () => {
      clearTimeout(timeoutId);
      document.removeEventListener('keydown', handleKeyDown, true);
    };
  }, [enabled, onEscape]);
}
